import React, {
  createContext,
  useContext,
  useState,
  useEffect,
} from 'react';

const HeaderExtensionsStateContext = createContext([]);
const HeaderExtensionsDispatchContext = createContext(() => {});

export function HeaderExtensionsProvider({ children }) {
  const [extensions, setExtensions] = useState([]);

  return (
    <HeaderExtensionsStateContext.Provider value={extensions}>
      <HeaderExtensionsDispatchContext.Provider value={setExtensions}>
        {children}
      </HeaderExtensionsDispatchContext.Provider>
    </HeaderExtensionsStateContext.Provider>
  );
}

export function useHeaderExtensions() {
  return useContext(HeaderExtensionsStateContext);
}

export function useSetHeaderExtensions() {
  return useContext(HeaderExtensionsDispatchContext);
}

export function useRegisterHeaderExtensions(extensions) {
  const setExtensions = useSetHeaderExtensions();

  useEffect(() => {
    setExtensions(extensions);
    return () => setExtensions([]);
  }, [extensions, setExtensions]);
}
